/* istanbul ignore file */
import { checkRouteExist, seoMapperConstant as CONSTANT } from '../../../shared/helpers/seoMap';

function redirectToNotFound() {
  window.location.href = '/404';
}

function isRouteExist(to, from, next) {
  let type = '';
  if (to.path.indexOf('/produk') >= 0) {
    type = CONSTANT.PRODUCT_KEY;
  } else if (to.path.indexOf('/jenis-reksa-dana') >= 0) {
    type = CONSTANT.TYPE_KEY;
  } else if (to.path.indexOf('/manajer-investasi') >= 0) {
    type = CONSTANT.INVESTMENT_MANAGER_KEY;
  }

  if (checkRouteExist(type, to.params.detail)) {
    next();
  } else {
    redirectToNotFound();
  }
}

export default {
  redirectToNotFound,
  isRouteExist,
};
